<script>
  import FancyTabs from '../lib/FancyTabs.svelte';
  import AllGainsForm from './Forms/AllGainsForm.svelte';
  import IndividualTradeForm from './Forms/IndividualTradeForm.svelte';

  $: tabs = [
    { title: "An individual trade", active: true },
    { title: "All of my crypto gains", active: false }
  ];

  const openForm = index => tabs = tabs.map((t, i) => ({ title: t.title, active: i == index }));

  $: activeTab = tabs.find(t => t.active);
</script>

<div class="w-full">
    <div class="flex flex-col items-center bg-primary-100 p-4">
      <div class="text-xl font-medium text-neutral-1200 mb-4">Calculate My 2024 Taxes For:</div>
      <FancyTabs tabs={tabs} onSelectTab={openForm} />
    </div>

    {#if activeTab.title == "An individual trade"}
      <IndividualTradeForm />
    {:else if activeTab.title = "All of my crypto gains"}
      <AllGainsForm />
    {/if}
</div>